<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <div class="modal-title">{{ title() || "Filters" }}</div>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    <form [formGroup]="parentForm()">
      @if (statusField()) {
        <app-chip-radio-button
          [parentForm]="parentForm()"
          [field]="statusField()"
          [currentValue]="parentForm().controls[statusField().key]?.value"
          [boldLabel]="false"
        ></app-chip-radio-button>
      }
      @if (modeField()) {
        <app-chip-radio-button
          [parentForm]="parentForm()"
          [field]="modeField()"
          [currentValue]="parentForm().controls[modeField().key]?.value"
          [boldLabel]="false"
        ></app-chip-radio-button>
      }
      @if (modulesField()) {
        <app-checkbox-group
          id="module-select"
          [parentForm]="parentForm()"
          [field]="modulesField()"
          [checkboxStyle]="checkboxStyle()"
          (checkboxClicked)="updateValue($event)"
        ></app-checkbox-group>
      }
      @if (offlineField()) {
        <div class="toggle-row">
          <label [for]="offlineField().key" [formGroup]="parentForm()">
            <div class="label-large">
              {{ offlineField().label }}
              @if (offlineField().required) {
                <span class="required" aria-required="true"> * </span>
              }
            </div>
            <mat-slide-toggle
              [id]="offlineField().key"
              [formControlName]="offlineField().key"
              ngDefaultControl
              color="primary"
            ></mat-slide-toggle>
          </label>
        </div>
      }
      @if (deletedField() && !hideDeletedField()) {
        <div class="toggle-row">
          <label [for]="deletedField().key" [formGroup]="parentForm()">
            <div class="label-large">
              {{ deletedField().label }}
              @if (deletedField().required) {
                <span class="required" aria-required="true"> * </span>
              }
            </div>
            <mat-slide-toggle
              [id]="deletedField().key"
              [formControlName]="deletedField().key"
              ngDefaultControl
              color="primary"
            ></mat-slide-toggle>
          </label>
        </div>
      }
    </form>
    <div class="button--container double">
      <app-button
        buttonStyle="secondary"
        [label]="secondaryButtonText()"
        [buttonId]="secondaryButtonId()"
        (buttonClicked)="buttonEventHandler(secondaryButtonId())"
        [isDisabled]="isProcessing()"
      ></app-button>
      <app-button
        [label]="primaryButtonText()"
        [buttonId]="primaryButtonId()"
        (buttonClicked)="buttonEventHandler(primaryButtonId())"
        [isDisabled]="isProcessing()"
      ></app-button>
    </div>
  </div>
</div>
<div class="modal--backdrop"></div>
